import PageLayout from './PageLayout';
import ContentTemplate from './ContentTemplate';
import LeftMenuTemplate from './LeftMenuTemplate';
import LoginContentTemplate from './LoginContentTemplate';
import NotLoginContentTemplate from './NotLoginContentTemplate';

export {
  PageLayout,
  ContentTemplate,
  LoginContentTemplate,
  NotLoginContentTemplate,
  LeftMenuTemplate,
};
